export default "__VITE_ASSET__BWHJsC_D__"